import { useEffect } from "react";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
import { Outlet } from "react-router-dom";

import { useMe } from "@/api/me";
import { FallbackComponent } from "@/components/layout/error-boundary";
import { useAuth } from "@/contexts/auth-context";

import logo from "@/assets/logo.svg";

const LoginLayout = () => {
  const { setUser } = useAuth();
  const { data: me, isLoading } = useMe();

  useEffect(() => {
    if (!isLoading) setUser(me || null);
  }, [isLoading, me, setUser]);

  return (
    <div className="flex flex-col items-center justify-center">
      <img
        className="absolute top-[5%] left-[5%]"
        width={"20%"}
        src={logo}
        alt={"Logo MyPerioApp"}
      />
      <div className="flex flex-col gap-14 pt-[10%] pb-[5%] max-w-[50%] w-full">
        <ReactErrorBoundary FallbackComponent={FallbackComponent}>
          <Outlet />
        </ReactErrorBoundary>
      </div>
    </div>
  );
};

export default LoginLayout;
